<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--main no-drag" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">
    <!-- side menu -->
    <v-nav-menu
      :navMenuItems="navMenuList"
      title="Vuexy"
      parent=".layout--main"
      @clickProjectChange="clickProjectChange"
    />

    <!-- footer menu -->
    <div class="footer-menu " :class="isShowFooterMenu ? 'show' : ''">
      <div class="footer-menu-wrap">
        <div class="footer-menu-background" @mouseenter="footerBgClick" @mousedown="footerBgClick"></div>
        <div class="footer-menu-contents-center">

          <!-- 긴급콜 -->
          <div class="quick-call" :class="isShowQuickCall ? '' : 'hidden'" style="position: relative">
            <div style="position: absolute; top:0; left:0; width:100%; hieght:100%; padding:40px 32px;">
              <p class="title">저장된 긴급콜센터로 연결됩니다.</p>
              <div class="list">
                <a class="list-item" href="tel:010-1234-5678"><img/><span>지정1 이름</span></a>
                <a class="list-item" href="tel:010-1234-5678"><img/><span>지정2 이름</span></a>
                <a class="list-item" href="tel:010-1234-5678"><img/><span>지정3 이름</span></a>
              </div>
              <div style="text-align: center;">
                <p class="mb-2">또는</p>
                <a
                  style="font-weight: 500; font-size: 14px; line-height: 28px; color: #353535; text-decoration-line: underline;"
                  href="tel:119">119 전화연결</a>
              </div>
            </div>
            <div style="position: absolute; top:0; right:0; padding:16px;" @click="hideFooterMenu()">
              <img src="@/assets/images/menu/menu-close.svg" alt="close">
            </div>
          </div>

        </div>
        <div class="footer-menu-contents">

          <!-- 프로젝트 변경-->
          <div class="select-project" :class="isShowSelectProject ? '' : 'hidden'">
            <div class="select-project-title">
              <span>기준 프로젝트</span>
              <img src="@/assets/images/icon/icon-warning.svg" alt="login" class="ml-2" style="margin-top:3px;">
              <vs-spacer/>
              <a @click="changeProject">프로젝트 변경</a>
            </div>
            <div class="select-project-list">

              <label
                v-for="(proj, index) in projectList" :key="index"
                class="select-project-list-item">
                <vs-radio v-model="selectProjectId" :vs-value="proj.id"
                          style="width:90%; overflow: hidden ; padding:0 18px; height:100%;"
                >
                  <span>{{ proj.field_name }}</span>
                </vs-radio>
                <vs-spacer/>
                <span style="padding:18px; width:80px; text-align: center;">선택</span>
              </label>
            </div>
          </div>

          <!-- 촬영 -->
          <div class="camera" :class="isShowCamera ? '' : 'hidden'">

            <div
              style="width: 100%; height: 100vw; overflow: hidden; display: flex; justify-content: center; position: relative;  align-items: flex-end">
              <img id="preview-image"
                   style="position: absolute; top:0; left:0; width:100%; height:100%; background: rgba(0,0,0,0.5); opacity: 0;">
              <vs-row id="preview-image-tool" style="display: none; width:100%;" class="mb-2" vs-justify="center">
                <vs-col class="w-1/2 pl-2 pr-1">
                  <vs-button class="w-full mr-4 " color="#EDEDED" text-color="black" type="filled"
                             @click="handlePreviewCancel">취소
                  </vs-button>
                </vs-col>
                <vs-col class="w-1/2 pl-1 pr-2 ">
                  <vs-button class="w-full" color="secondary" @click="handlePreviewSave">올리기</vs-button>
                </vs-col>
              </vs-row>
            </div>

            <div class="camera-item">
              <label v-if="isDevice" class="w-full" @click="onClickPhoto">
                <div style="width:110px; display:flex; justify-content: start; align-items: center;">
                  <img src="@/assets/images/icon/icon-camera.svg" alt="login" class="mr-2" style="width:24px;">
                  사진 촬영
                </div>
              </label>
              <label v-else class="w-full">
                <div style="width:110px; display:flex; justify-content: start; align-items: center;">
                  <vs-input id="take-picture-image" type="file" accept="image/*" capture="camera" style="display: none;"
                            @change="changeImage"></vs-input>
                  <!--<input type="file" id="take-picture-image" accept="image/*" capture="camera" style="display: none;" @change="changeImage">-->
                  <img src="@/assets/images/icon/icon-camera.svg" alt="login" class="mr-2" style="width:24px;">
                  사진 촬영
                </div>
              </label>
            </div>
            <!--
            <div class="camera-item">
              <label class="w-full">
                <div style="width:110px; display:flex; justify-content: start; align-items: center;">
                  <input type="file" id="take-picture-camera" accept="video/*" capture="camera" style="display: none;" @change="changeVideo">
                  <img src="@/assets/images/icon/icon-video.svg" alt="login" class="mr-2" style="width:24px;">
                  동영상 촬영
                </div>
              </label>
            </div>
            -->
            <div class="camera-item">
              <label class="w-full" @click="movePhotoAlbum">
                <div style="width:110px; display:flex; justify-content: start; align-items: center;">
                  <img src="@/assets/images/icon/icon-folder.svg" alt="login" class="mr-2" style="width:24px;">
                  촬영 보관함
                </div>
              </label>
            </div>
            <div class="camera-item">
              <label class="w-full" @click="closePopup">
                <div style="width:110px; display:flex; justify-content: start; align-items: center;">
                  <div class="mr-2" style="width:24px; display:flex; justify-content: center; align-items: center">
                    <img src="@/assets/images/icon/icon-close.svg" alt="login">
                  </div>
                  닫기
                </div>
              </label>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay"/>

      <!-- Navbar -->
      <template>
        <div class="relative">

          <div class="vx-navbar-wrapper m-main p-0">

            <div class="w-full flex"
                 style="background:#1E0D61; color:#cdcdcd; height:54px; padding:13px 16px; align-items: center;"
                 @click="moveMyPage">
              <a :href="homeUrl"><img src="@/assets/images/logo/m-maot-logo.svg" alt="login" class="mx-auto"></a>
              <vs-spacer/>
              <span>{{ $t('nav.profile.hello') }} {{ userInfo.name }}님</span>
            </div>

            <div class="w-full grid"
                 style="background:#FAFAFA; color:#353535; font-weight:normal; height:56px; padding:0px 16px; align-items: center;
                        border-bottom:1px solid #dedede; grid-template-columns: 38px 1fr 38px; justify-content: center; text-align: center;">
              <a v-if="isHome">
                <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="HomeIcon"/>
              </a>
              <a v-else href="javascript:;">
                <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="ChevronLeftIcon" @click="back"/>
              </a>
              <h4 @click="showSelectProject"> {{ getTitle(projectInfo.field_name) }} </h4>
              <a href="javascript:;" @click="showSidebar">
                <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon"/>
              </a>
            </div>
          </div>
        </div>
      </template>
      <!-- /Navbar -->

      <div class="content-wrapper">

        <div class="router-view">
          <div class="router-content m-main">

            <div class="content-area__content">

              <back-to-top style="bottom:80px;" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'"
                           visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top"/>
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"
                             @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)"/>
              </transition>
            </div>
          </div>
        </div>
      </div>


      <footer class="the-footer flex-wrap justify-between p-0"
              style="position: fixed; left:0; right:0; bottom:0; height:60px; z-index:41001;
                      background: #FFFFFF; box-shadow: 1px -1px 8px rgba(0, 0, 0, 0.15);">
        <div class="w-full h-full"
             style="display: grid; grid-template-columns: 0.6fr 1.4fr 1fr 1fr 1fr; align-items: center; justify-content: center; text-align: center; padding:0 16px; ">
          <div @click.stop="gnbClickMenu(0)"><span style="font-weight: 500; font-size: 15px; color: #353535;">홈</span>
          </div>
          <div @click.stop="gnbClickMenu(1)"><span style="font-weight: 500; font-size: 15px; color: #D80000;">긴급콜</span>
          </div>
          <div @click.stop="gnbClickMenu(2)"><img src="@/assets/images/menu/menu-camera.svg" alt="login"
                                                  style="margin-top:-20px; width:72px;"></div>
          <div @click.stop="gnbClickMenu(3)"><span style="font-weight: 500; font-size: 15px; color: #353535;">알림</span>
          </div>
          <div @click.stop="gnbClickMenu(4)"><span
            style="font-weight: 500; font-size: 15px; color: #353535;">출역체크</span></div>
        </div>
      </footer>
    </div>
  </div>
</template>


<script>
import BackToTop from 'vue-backtotop'
import navMenuItems from '@/layouts/m/project/sidebarItems'
import TheNavbarVertical from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter from '@/layouts/components/TheFooter.vue'
import themeConfig from '@/../themeConfig.js'
import VNavMenu from '@/layouts/components/vertical-nav-menu/MobileVerticalNavMenu.vue'

export default {
  components: {
    BackToTop,
    TheFooter,
    TheNavbarVertical,
    VNavMenu
  },
  data () {
    return {
      footerType: themeConfig.footerType || 'static',
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || '#fff',
      navbarType: themeConfig.navbarType || 'floating',
      navMenuItems,
      routerTransition: themeConfig.routerTransition || 'none',
      routeTitle: this.$route.meta.pageTitle,
      rootPath: `/m/project/${this.$route.params.proj_id}`,
      selectProjectId: this.$route.params.proj_id,
      isShowFooterMenu: false,
      isShowSelectProject: false,
      isShowCamera: false,
      isShowQuickCall: false,
      imageFiles: []
    }
  },
  watch: {
    '$route' () {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark (val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff'
      this.updateNavbarColor(color)
    },
    '$store.state.mainLayoutType' (val) {
      this.setNavMenuVisibility(val)
    }
  },
  computed: {
    bodyOverlay () {
      return this.$store.state.bodyOverlay
    },
    contentAreaClass () {
      if (this.mainLayoutType === 'vertical') {
        if (this.verticalNavMenuWidth === 'default') return 'content-area-reduced'
        else if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg'
        else return 'content-area-full'
      } else return 'content-area-full'
    },
    footerClasses () {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      }
    },
    isAppPage () {
      return this.$route.meta.no_scroll
    },
    isThemeDark () {
      return this.$store.state.theme === 'dark'
    },
    layoutTypeClass () {
      return `main-${this.mainLayoutType}`
    },
    mainLayoutType () {
      return this.$store.state.mainLayoutType
    },
    navbarClasses () {
      return {
        'navbar-hidden': this.navbarType === 'hidden',
        'navbar-sticky': this.navbarType === 'sticky',
        'navbar-static': this.navbarType === 'static',
        'navbar-floating': this.navbarType === 'floating'
      }
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },
    userInfo () {
      return this.$store.state.auth.userInfo
    },
    myInfo () {
      if (sessionStorage.getItem('myInfo')) {
        return JSON.parse(sessionStorage.getItem('myInfo'))
      } else {
        return {}
      }
    },
    projectInfo () {
      return this.$store.state.project.projectInfo
    },
    projectList () {
      return this.$store.state.project.projectListInfo.data
    },
    isHome () {
      if (`/m/project/${this.projectInfo.id}/home` === this.$route.path) {
        return true
      }
      return false
    },
    homeUrl () {
      return `/m/project/${this.projectInfo.id}/home`
    },
    navMenuList () {
      const list = JSON.parse(JSON.stringify(this.navMenuItems))
      this.changeNav(list)
      return list
    },
    isDevice () {
      if (window.PhotoAlbum && window.PhotoAlbum.postMessage) {
        return true
      }

      return false
    }
  },
  methods: {


    changeNav (list) {

      if (list && list.length > 0) {
        for (const item of list) {
          item.name = this.$t(`nav.mobile.${item.name}`)
          if (item.submenu && item.submenu.length > 0) {
            this.changeNav(item.submenu)
          }
        }
      }

    },

    changeRouteTitle (title) {
      this.routeTitle = title
    },
    updateNavbarColor (val) {
      this.navbarColor = val
      if (val === '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    setNavMenuVisibility (layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === 'vertical' && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    renameKey (obj, oldKey, newKey) {
      obj[newKey] = obj[oldKey]
      delete obj[oldKey]
    },
    back () {
      this.$router.back()
    },
    getTitle (title) {
      if (title) {
        let newTitle = ''
        newTitle += title.toString().substr(0, 14)
        newTitle += (title.toString().length > 14) ? '...' : ''
        return newTitle
      }
      return ''
    },

    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    },

    gnbClickMenu (index) {
      if (index === 0) {
        this.selectProjectId = this.$route.params.proj_id
        this.changeProject()
      } else if (index === 1) {
        this.showQuickCall()
      } else if (index === 2) {
        this.showCamera()
      } else if (index === 3) {
        this.$router.replace(`/m/project/${this.projectInfo.id}/alert`)
      } else if (index === 4) {
        this.$router.replace(`/m/project/${this.projectInfo.id}/input-check`)
      }
    },

    changeProject () {
      const userId = this.$store.state.auth.userInfo.id
      const projectId = this.selectProjectId
      localStorage.setItem(`save_proj_id_${userId}`, projectId)
      this.$router.push({path: `/m/project/${this.selectProjectId}`})
    },

    footerBgClick () {
      this.hideFooterMenu()
    },

    showSelectProject () {
      this.isShowFooterMenu = true
      this.isShowSelectProject = true
    },

    showQuickCall () {
      this.isShowFooterMenu = true
      this.isShowQuickCall = true
    },

    showCamera () {
      this.isShowFooterMenu = true
      this.isShowCamera = true
    },

    hideFooterMenu () {
      this.selectProjectId = this.$route.params.proj_id
      this.isShowFooterMenu = false
      this.isShowSelectProject = false
      this.isShowCamera = false
      this.isShowQuickCall = false
    },

    changeImage (event) {
      const files = event.target.files
      this.imageFiles = files
      if (files && files[0]) {
        const reader = new FileReader()

        reader.onload = function (e) {
          document.getElementById('preview-image').setAttribute('src', e.target.result)
          document.getElementById('preview-image').setAttribute('style', 'position: absolute; top:0; left:0; width:100%; height:100%; background: rgba(0,0,0,0.5); ')
          document.getElementById('preview-image-tool').setAttribute('style', 'display:block; width:100%; ')
        }

        reader.readAsDataURL(files[0])
      }
    },

    handlePreviewCancel () {
      document.getElementById('preview-image').setAttribute('src', '')
      document.getElementById('preview-image').setAttribute('style', 'position: absolute; top:0; left:0; width:100%; height:100%; background: rgba(0,0,0,0.5); opacity: 0;')
      document.getElementById('preview-image-tool').setAttribute('style', 'display:none;')
    },

    handlePreviewSave () {
      this.file_upload(this.imageFiles)
    },

    async file_upload (files) {
      if (files.length > 0) {
        await this.$store.dispatch('file/FILE_UPLOAD', files[0])
        this.file = this.$store.state.file.uploadedFile

        location.reload()
      }
    },

    changeVideo (event) {
      const files = event.target.files
      if (files && files[0]) {
        const $source = document.getElementById('preview-video-source')
        $source.src = URL.createObjectURL(files[0])
        const parent = document.getElementById('preview-video')
        parent.load()
      }
    },

    clickProjectChange () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
      this.showSelectProject()
    },

    movePhotoAlbum () {

      if (window.PhotoAlbum && window.PhotoAlbum.postMessage) {
        window.PhotoAlbum.postMessage(JSON.stringify({
          command: 'openPhotoAlbum'
        }))
      } else {
        this.$router.push(`/m/project/${this.projectInfo.id}/photo-album`)
      }
    },
    onClickPhoto () {
      if (window.PhotoAlbum && window.PhotoAlbum.postMessage) {
        window.PhotoAlbum.postMessage(JSON.stringify({
          command: 'openPhoto'
        }))
      }
    },

    // Mypage로 이동
    moveMyPage () {
      this.$router.push(`/m/project/${this.$route.params.proj_id}/mypage/info-update`)
    },

    closePopup () {
      this.hideFooterMenu()
    }

  },
  async beforeCreate () {

    // 회원정보 불러오기
    await this.$store.dispatch('USER_INFO')
    const userId = this.$store.state.auth.userInfo.id
    await this.$store.dispatch('member/LOAD_MEMBER', {userId})
    sessionStorage.setItem('myInfo', JSON.stringify(this.$store.state.member.memberInfo))
    await this.$store.dispatch('SET_MY_INFO')

    await this.$store.dispatch('member/LOAD_MEMBERS_ALL', {})

    const project_id = this.$route.params.proj_id
    this.selectProjectId = project_id
    await this.$store.dispatch('project/LOAD_PROJECT', {project_id})

    const page = 1
    const perPage = 100
    await this.$store.dispatch('project/LOAD_PROJECT_LIST', {
      page,
      perPage
    })
  },

  created () {
    const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)
  }
}

</script>

<style scoped>
.footer-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-transition: all .3s ease;
  transition: all .3s ease;
  opacity: 1;
}

.footer-menu .footer-menu-wrap {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.footer-menu .footer-menu-background {
  position: absolute;
  top: 0;
  left: 0;
  background: none;
  width: 100%;
  height: 100%;
  transition: all .4s ease;
}

.footer-menu .footer-menu-contents-center {
  position: absolute;
  transition: all .2s ease;
  top: 50%;
  left: 50%;
}

.footer-menu .footer-menu-contents {
  position: absolute;
  left: 0;
  bottom: -400px;
  width: 100%;
  transition: all .2s ease;
}

.footer-menu .footer-menu-contents .select-project div {
  background: #fff;
  padding: 0px;
}

.footer-menu .footer-menu-contents .select-project .select-project-title {
  border-radius: 8px 8px 0px 0px;
  height: 68px;
  border-bottom: 1px solid #cdcdcd;
  padding: 18px;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
}

.footer-menu .footer-menu-contents .select-project .select-project-list {
  height: 204px;
  overflow-y: auto;
}

.footer-menu .footer-menu-contents .select-project .select-project-list .select-project-list-item {
  height: 68px;
  border-bottom: 1px solid #cdcdcd;
  display: flex;
  align-items: center;
}

.footer-menu .footer-menu-contents .select-project .select-project-list .select-project-list-item:last-child {
  border-bottom: none;
}

.footer-menu .footer-menu-contents .camera .camera-item {
  display: flex;
  justify-content: center;

  background: #fff;
  padding: 0px;
  height: 68px;

  border-top: 1px solid #cdcdcd;
}

.footer-menu .footer-menu-contents .camera .camera-item:first-child {
  border-radius: 8px 8px 0px 0px;
  border-top: none;
}

.footer-menu .footer-menu-contents .camera .camera-item label {
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-menu .footer-menu-contents-center .quick-call {
  width: 90vw;
  height: 90vw;
  max-width: 320px;
  max-height: 307px;
  margin-top: -50%;
  margin-left: -50%;
  background: #fff;

  border-radius: 8px;
}

.footer-menu .footer-menu-contents-center .quick-call .title {
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  line-height: 36px;
  margin-bottom: 16px;
}

.footer-menu .footer-menu-contents-center .quick-call .list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 32px;
  margin-bottom: 24px;
}

.footer-menu .footer-menu-contents-center .quick-call .list .list-item {
  display: grid;
  justify-content: center;
  align-items: center;
}

.footer-menu .footer-menu-contents-center .quick-call .list .list-item img {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #c4c4c4;
}

.footer-menu .footer-menu-contents-center .quick-call .list .list-item span {
  font-weight: normal;
  font-size: 12px;
  line-height: 36px;
  text-align: center;
}


.footer-menu.show {
  z-index: 51001;
}

.footer-menu.show .footer-menu-background {
  background: rgba(0, 0, 0, .2);
}

.footer-menu.show .footer-menu-contents {
  bottom: 0;
}

</style>

<style>
[dir] input[readonly='readonly'] {
  background-color: #fafafa;
}

[dir] textarea[readonly='readonly'] {
  background-color: #fafafa;
}

[dir] .file-input .vs-con-input .vs-inputx {
  background-color: #ffffff;
}

[dir] .con-select .vs-select--input {
  background-color: #ffffff;
}

[dir] .vdp-datepicker input[readonly='readonly'] {
  background-color: #ffffff;
}

/* 페이지네이션 중앙 정렬 */
[dir] .vs-con-table .vs-table--pagination .vs-row .vs-col:nth-child(1) {
  display: none !important;
}

[dir] .vs-con-table .vs-table--pagination .vs-row .vs-col:nth-child(2) {
  width: 100% !important;
  justify-content: center !important;
}

/* 페이지네이션 현재페이지 색상 */
[dir] .vs-con-table .vs-table--pagination .vs-pagination-primary .effect,
[dir] .vs-con-table .vs-table--pagination .vs-pagination-primary .vs-pagination--buttons:hover {
  background: rgba(var(--vs-secondary), 1) !important;
}

/* 리스트 스타일 */
.dot {
  width: 10px;
  height: 10px;
  margin-right: 8px;
  border-radius: 10px;
  display: inline-block;
  background-color: #6670CB;
}

.dot.red {
  background-color: #fb0000;
}

.dot.yellow {
  background-color: #FFD600;
}

/* 테이블 스타일 */
ul.table {
  width: 100%;
}

ul.table > li {
  display: grid;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #cdcdcd;
  grid-template-rows: minmax(52px, 100%);
}

ul.table > li.tbody {
  background-color: #fff;
}

ul.table > li.tbody > span {
  font-weight: normal !important;
}

ul.table > li > span {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #cdcdcd;
  padding: 6px;
  font-weight: 500;
}

ul.table > li > span:first-child {
  border-left: none;
}

ul.table.table-2 > li {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

ul.table.table-3 > li {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

ul.table.table-4 > li {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

ul.table.table-5 > li {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

ul.table.table-6 > li {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

ul.table.table-7 > li {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

ul.table.table-8 > li {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

ul.table.table-9 > li {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}

ul.table.table-10 > li {
  grid-template-columns:50px repeat(9, minmax(0, 1fr));
}

ul.table.table-no > li {
  grid-template-columns: 60px minmax(0, 100%);
}

ul.table > li.table-2-li {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

ul.table > li.table-3-li {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

ul.table > li.table-4-li {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

ul.table > li.table-5-li {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

ul.table > li.table-6-li {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

ul.table > li.table-7-li {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

ul.table > li.table-8-li {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

ul.table > li.table-9-li {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}

ul.table > li.table-10-li {
  grid-template-columns:50px repeat(9, minmax(0, 1fr));
}

ul.table > li.table-no-li {
  grid-template-columns: 60px minmax(0, 100%);
}

.vs-row .border {
  border: 1px solid #cdcdcd;
  text-align: center;
  background-color: #F9F9F9;
}

.bg-fff {
  background-color: #fff;
}

.border-left {
  border-left: 1px solid #cdcdcd !important;
}

.border-right {
  border-right: 1px solid #cdcdcd !important;
}

.border-bottom {
  border-bottom: 1px solid #cdcdcd !important;
}

.border-top {
  border-top: 1px solid #cdcdcd !important;
}

.title {
  font-weight: 500;
}

.no-drag {
  -ms-user-select: none;
  -moz-user-select: -moz-none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}
</style>

